export enum UploadProcessingEventType {
  RelativityPreparingProgress = 'relativity-preparing-progress',
  RelativityFileDownloaded = 'relativity-file-downloaded',
  ExtractingStarted = 'extracting-started',
  ExtractingProgress = 'extracting-progress',
  ExtractingComplete = 'extracting-complete',
  FilesQueued = 'files-queued',
  FileDeduplicated = 'file-deduplicated',
  EmailUnpackingSkipped = 'email-unpacking-skipped',
  FileError = 'file-error',
  ProcessingComplete = 'processing-complete',
  ProcessingFailed = 'processing-failed',
}
